import { AsyncPipe, JsonPipe, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CuttingStandardCutout, ICustomResponse } from 'cloud-shared-lib';
import { StandardCutoutSelectComponent } from 'projects/cloud-shared-lib/src/lib/components/standard-cutout-select/standard-cutout-select.component';
import { Observable } from 'rxjs';
import { skip } from 'rxjs/operators';

import { MatSortModule, Sort } from '@angular/material/sort';
import { CuttingPanelListService } from '../../../cutting-panel-list/cutting-panel-list.service';

@Component({
  selector: 'csl-standard-cutouts',
  templateUrl: './standard-cutouts.component.html',
  standalone: true,
  imports: [StandardCutoutSelectComponent, NgIf, JsonPipe, AsyncPipe, MatSortModule],
})
export class StandardCutoutsComponent implements OnChanges {
  @Input() groupId: number;
  data$: Observable<ICustomResponse<CuttingStandardCutout[]>>;

  @Output() selectChanged: EventEmitter<CuttingStandardCutout> = new EventEmitter();

  constructor(private cuttingPanelListService: CuttingPanelListService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.groupId?.currentValue) {
      this.data$ = this.cuttingPanelListService.getStandardCutouts(this.groupId).pipe(skip(1));
    }
  }

  sortData(sort: Sort): void {
    this.data$ = this.cuttingPanelListService.getStandardCutouts(this.groupId, sort);
  }
}
